import { CurrencyModel } from './currency.model';


export const CURRENCY_LIST: CurrencyModel[] = [
  {
    name: 'US Dollar',
    code: 'USD'
  },
  {
    name: 'Mexican Peso',
    code: 'MXN'
  },
  {
    name: 'Canadian Dollar',
    code: 'CAD'
  }
];
